<tt-page *ngIf="!!setting">
    <tt-page-heading *ngIf="!!setting.page_heading" [ttModel]="setting.page_heading"></tt-page-heading>

    <tt-card class="col-xs-12 col-md-4 sp-0">
        <div *ngFor="let item of inputListCustomerFacts">
            <tt-textarea *ngIf="item.elementtype === 'T'" [ttLabel]="item.facts_name" [(ttModel)]="item.note"></tt-textarea>
            <tt-input-number *ngIf="item.elementtype === 'N2'" [ttLabel]="item.facts_name" [(ttModel)]="item.note" ttTextAlign="right" ttFormatNumber ttDecimals="2"></tt-input-number>
            <tt-checkbox *ngIf="item.elementtype === 'CB'" [ttLabel]="item.facts_name" [(ttModel)]="item.checkbox"></tt-checkbox>
        </div>

        <tt-button-save ttText="custfacts_save" (ttClick)="saveChanges()" [ttLoading]="saving"></tt-button-save>
    </tt-card>
</tt-page>
